module.exports = __webpack_public_path__ + "static/media/logo_only@3x.efb99ce4.png";